import { render, staticRenderFns } from "./DeliveryDateExtended.vue?vue&type=template&id=623ef430&"
import script from "./DeliveryDateExtended.vue?vue&type=script&lang=js&"
export * from "./DeliveryDateExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports